module.exports = __webpack_public_path__ + "img/jp.0029dbad.png";